import React, { useState, useEffect } from 'react';
import Reader2 from './Reader2.0';
import Reader2Mobile from './Reader2.0-Mobile';
import PageFlipReader from './PageFlipReader';

const ResponsiveReader = ({ onClose, onBackToWebsite, usePageFlip = false }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1200); // Use mobile view for tablets and smaller screens
    };

    // Check on mount
    checkScreenSize();

    // Add resize listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Render appropriate reader based on page flip preference
  if (usePageFlip) {
    return (
      <PageFlipReader 
        onClose={onClose}
        onBackToWebsite={onBackToWebsite}
      />
    );
  }

  // Fallback to responsive readers based on screen size
  if (isMobile) {
    return (
      <Reader2Mobile 
        onClose={onClose}
        onBackToWebsite={onBackToWebsite}
      />
    );
  }

  return (
    <Reader2 
      onClose={onClose}
      onBackToWebsite={onBackToWebsite}
    />
  );
};

export default ResponsiveReader;
